<template>
  <div>
    <header class="section-header section-header--lg mt-3">
      <div>
        <h1 class="heading" qaid="page-title">{{ bp('confirmPurchase') }}</h1>
      </div>
    </header>
    <p class="text-base italic">{{ resultStringAndNumber }}</p>
    <div v-if="bikeNotFound" class="cell mt-1">
      <pdl-callout kind="warning">
        <template #content>
          <span v-html="bikeNotFound" />
        </template>
      </pdl-callout>
    </div>
    <div class="grid-x grid-margin-x small-up-1 medium-up-2 large-up-3 my-5" qaid="bike-results-section">
      <div v-for="(item, index) in bikes" :key="index" class="cell b2b-card b2b-card--padded" qaid="bike-results-card">
        <div class="b2b-card__img b2b-card__img--padded">
          <img :src="item.imageUrl || noBikeImage" />
        </div>

        <div class="b2b-card__footer b2b-card__footer--short b2b-card__footer--border">
          <label :key="index" :qaid="`option-${index}`" :for="`option-${index}`" class="radio m-0">
            <input
              :id="`option-${index}`"
              v-model="pickedBike"
              type="radio"
              name="user-role"
              :value="item.sku"
              :qaid="`option-${index}`"
              required="required"
            />
            <span class="control-indicator"></span>
            {{ item.description }}
          </label>
        </div>
      </div>
    </div>

    <div class="buttons">
      <trek-link button primary :disabled="!pickedBike" :href="registerUrl" qaid="bike-result-continue-button">
        <span v-html="bp('continueButton')" />
      </trek-link>
      <trek-link button secondary :href="notFoundUrl" qaid="bike-result-not-found-button">
        <span v-html="bp('bikeNotShownButton')" />
      </trek-link>
    </div>

    <a
      class="underline hover:no-underline"
      :href="contactUsUrl"
      qaid="bike-result-request-support-link"
      v-html="bp('requestSupport')"
    />
  </div>
</template>
<script>
import TrekLink from '@/components/TrekLink';
import {mapState} from 'vuex';

export default {
  components: {TrekLink},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    bikes: {
      type: Array,
      default: () => [],
    },
    contextPath: {
      type: String,
      default: '',
    },
    bikeNotFound: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      pickedBike: '',
      noBikeImage:
        'https://trek.scene7.com/is/image/TrekBicycleProducts/Product-Registration_No-Bike-Image-Found?$responsive-pjpg$&wid=800&hei=600',
      resultStringAndNumber: '',
    };
  },

  computed: {
    registerUrl() {
      return (window.location.href + this.pickedBike).replace('serial', 'verify') + '/';
    },
    notFoundUrl() {
      return `${this.contextPath}/${this.b2b ? 'bike-registration' : 'productRegistration'}/bike-not-found/`;
    },
    contactUsUrl() {
      return `${this.contextPath}/${this.b2b ? 'contact-us' : 'contactUs'}`;
    },
    ...mapState('backend', ['b2b']),
  },
  mounted() {
    this.resultStringAndNumber = this.getBaseProperty('resultsFound').replace('{0}', this.bikes.length);
  },
};
</script>
